__turbopack_context__.v({
  "bazaarvoice-review-photo__button": "bazaarvoice-review-photo-module-scss-module__H5eoDG__bazaarvoice-review-photo__button",
  "bazaarvoice-review-photo__full-size-image": "bazaarvoice-review-photo-module-scss-module__H5eoDG__bazaarvoice-review-photo__full-size-image",
  "bazaarvoice-review-photo__full-size-wrapper": "bazaarvoice-review-photo-module-scss-module__H5eoDG__bazaarvoice-review-photo__full-size-wrapper",
  "bazaarvoice-review-photo__image": "bazaarvoice-review-photo-module-scss-module__H5eoDG__bazaarvoice-review-photo__image",
  "bazaarvoice-review-photo__tile": "bazaarvoice-review-photo-module-scss-module__H5eoDG__bazaarvoice-review-photo__tile",
});
